import { MapPin, Truck } from "lucide-react";
import { PageHeader } from "@/components/storefront/PageHeader";
import { Seo } from "@/components/Seo";
import { Card, CardContent } from "@/components/ui/card";
import { usePageContent, useSite } from "@/context/SiteContext";
import { money } from "@/lib/api";

export default function Delivery() {
  const content = usePageContent("delivery_page");
  const { settings } = useSite();
  const delivery = settings?.delivery || {};

  return (
    <div data-testid="delivery-page">
      <Seo title={content?.seo_title} description={content?.seo_description} />
      <PageHeader title={content?.title || "Delivery"} testId="delivery-header" />
      <div className="max-w-4xl mx-auto px-4 pb-10 space-y-8">
        {(content?.body || "").split("\n\n").filter(Boolean).map((p, i) => (
          <p key={i} className="text-muted-foreground leading-relaxed text-base md:text-lg">{p}</p>
        ))}
        {settings?.delivery?.info && <p className="text-muted-foreground leading-relaxed">{settings.delivery.info}</p>}

        <div className="grid sm:grid-cols-2 gap-6">
          <Card data-testid="delivery-charges-card">
            <CardContent className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2.5 rounded-full bg-primary/10 text-primary"><Truck className="h-5 w-5" /></div>
                <h2 className="font-display text-xl">Delivery Charges</h2>
              </div>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li data-testid="delivery-fee">Local delivery: <strong className="text-foreground">{money(delivery.fee || 0)}</strong></li>
                {delivery.free_delivery_enabled !== false && Number(delivery.free_over) > 0 && (
                  <li data-testid="delivery-free-over">Free delivery on orders over <strong className="text-foreground">{money(delivery.free_over)}</strong></li>
                )}
                {Number(delivery.min_order) > 0 && (
                  <li data-testid="delivery-min-order">Minimum order value: <strong className="text-foreground">{money(delivery.min_order)}</strong></li>
                )}
              </ul>
            </CardContent>
          </Card>
          <Card data-testid="delivery-areas-card">
            <CardContent className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2.5 rounded-full bg-primary/10 text-primary"><MapPin className="h-5 w-5" /></div>
                <h2 className="font-display text-xl">Areas We Cover</h2>
              </div>
              <div className="flex flex-wrap gap-2" data-testid="delivery-areas">
                {(delivery.areas || []).map((a) => (
                  <span key={a} className="px-3 py-1.5 rounded-full bg-secondary/60 dark:bg-secondary/30 text-sm">{a}</span>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>

        {delivery.notes && <p className="text-sm text-muted-foreground border-l-2 border-primary/40 pl-4" data-testid="delivery-notes">{delivery.notes}</p>}
      </div>
    </div>
  );
}
